import * as views from "../views";
import EmptyView from "@/core/components/EmptyView.vue";
import { i18nFormat } from "@/i18n.js";

export default [
  {
    path: "store",
    component: EmptyView,
    meta: {
      headerVisible: false
    },
    children: [
      {
        path: "settings",
        name: "StoreSettings",
        component: views.Settings,
        meta: {
          headerVisible: true,
          headerTitle: i18nFormat("t", "storeSettings.headerTitle"),
          headerDescription: i18nFormat("t", "storeSettings.headerDesc"),
          headerDomain: null,
          allowAutoSidebar: true
        }
      },
      {
        path: "activity-log",
        name: "ActivityLog",
        component: views.ActivityLog,
        meta: {
          headerVisible: true,
          headerTitle: i18nFormat("t", "storeSettings.eventLogs.title"),
          headerDescription: i18nFormat("t", "storeSettings.eventLogs.desc"),
          headerDomain: null,
          allowAutoSidebar: true
        }
      },
    ]
  }
];
